/* L&P diamond quiz — engine. David quiz structure and look (gate → Q1 split → colour →
   shape → wear/moment → fact → objection → answer → loader → result → collection
   reveal), the studded collection, the V2 offer (mystery gift ₪400 ומעלה + 1+1 +
   30 days + 24h), the L&P tracking stack. Content lives in lp-quiz-diamond-data.js.
   Nothing here is shared with lp-quiz.js or lp-quiz-david.js. */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  window.__lpDiamondQuizV = '1.0';
  try { console.log('[lp-quiz-diamond] v' + window.__lpDiamondQuizV + ' loaded'); } catch (e) {}

  var root = document.querySelector('[data-lp-diamond-quiz]');
  var D = window.LP_DIAMOND;
  if (!root || !D) return;

  var CFG = {};
  try { CFG = JSON.parse(root.querySelector('[data-dq-config]').textContent || '{}'); } catch (e) { CFG = {}; }

  var VARIANT = CFG.variant || 'diamond';
  try { window.__lpQuizVariant = VARIANT; } catch (e) {}
  var SITE = CFG.site || 'https://lapoedagar.com';
  var COLL = CFG.collection_url || '/collections/%D7%A9%D7%A2%D7%95%D7%A0%D7%99%D7%9D-%D7%9E%D7%A9%D7%95%D7%91%D7%A6%D7%99%D7%9D-%F0%9F%92%8E';
  var SOCIAL = CFG.social_count || '13,336';
  var HERO = CFG.hero_url || '';
  var GATE = CFG.gate || {};
  var MYSTERY_VARIANT_ID = CFG.mystery_variant_id || 45928714698943;

  /* ═══ tracking — same stack as the L&P quiz ═══ */
  var PIXELS = { meta: CFG.meta_pixel_id || '1639506919964880', tiktok: CFG.tiktok_pixel_id || 'CJL66RBC77UEAFO1GRPG', google: CFG.google_ads_id || 'AW-17548706483' };
  var GADS_CONV = CFG.gads_conv || { QuizComplete: 'AW-17548706483/C0c0CNnw4dscELOF8K9B', QuizGiftClick: 'AW-17548706483/_ZM6CNzw4dscELOF8K9B' };

  try {
    if (!window.fbq) {
      !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', PIXELS.meta);
    } else {
      /* fbq is already on the page: the theme loads the SAME pixel id before this asset runs.
         Re-initialising an id Meta already has makes it log "Duplicate Pixel ID" and count
         PageView twice, which inflates the numbers a campaign optimises on. Only init when
         this pixel is genuinely absent. (QA 2026-09-06, F1) */
      try {
        var lpByID = window.fbq.instance && window.fbq.instance.pixelsByID;
        if (lpByID && !lpByID[PIXELS.meta]) fbq('init', PIXELS.meta);
      } catch (e) {}
    }
  } catch (e) {}
  try {
    if (!window.ttq) {
      !function (w, d, t) { w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent']; ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; }; for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; }; ttq.load = function (e, n) { var r = 'https://analytics.tiktok.com/i18n/pixel/events.js'; ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r; ttq._t = ttq._t || {}; ttq._t[e] = +new Date; ttq._o = ttq._o || {}; ttq._o[e] = n || {}; var a = document.createElement('script'); a.type = 'text/javascript'; a.async = !0; a.src = r + '?sdkid=' + e + '&lib=' + t; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(a, s); }; ttq.load(PIXELS.tiktok); }(window, document, 'ttq');
    }
  } catch (e) {}
  try {
    if (!window.gtag) {
      var gs = document.createElement('script'); gs.async = true;
      gs.src = 'https://www.googletagmanager.com/gtag/js?id=' + PIXELS.google;
      document.head.appendChild(gs);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { dataLayer.push(arguments); };
      gtag('js', new Date());
    }
    gtag('config', PIXELS.google, { send_page_view: false });
  } catch (e) {}

  function detectSrc() {
    try {
      var p = new URLSearchParams(location.search);
      if (p.get('src')) return p.get('src');
      if (p.has('fbclid')) return 'meta';
      if (p.has('ttclid')) return 'tiktok';
      if (p.has('gclid') || p.has('gbraid') || p.has('wbraid')) return 'google';
      if (p.get('utm_source')) return p.get('utm_source');
      var saved = sessionStorage.getItem('lp_quiz_src'); if (saved) return saved;
      var r = document.referrer || '';
      if (/facebook\.|instagram\./.test(r)) return 'meta';
      if (/tiktok\./.test(r)) return 'tiktok';
      if (/google\.|youtube\./.test(r)) return 'google';
      return 'direct';
    } catch (e) { return 'direct'; }
  }
  var QSRC = detectSrc();
  try { sessionStorage.setItem('lp_quiz_src', QSRC); } catch (e) {}
  function detectAd() {
    try {
      var p = new URLSearchParams(location.search), parts = [];
      var camp = p.get('gcamp') || p.get('utm_campaign') || p.get('campaign_id') || '';
      var adset = p.get('gadset') || p.get('utm_medium_id') || p.get('adset_id') || '';
      var ad = p.get('gad') || p.get('utm_content') || p.get('ad_id') || '';
      if (camp) parts.push('c:' + camp); if (adset) parts.push('s:' + adset); if (ad) parts.push('a:' + ad);
      if (parts.length) { var v = parts.join('|'); sessionStorage.setItem('lp_quiz_ad', v); return v; }
      return sessionStorage.getItem('lp_quiz_ad') || '';
    } catch (e) { return ''; }
  }
  var QAD = detectAd();

  /* journey log — same Google Form as the L&P quiz, variant stamped v:david */
  var JOURNEY = CFG.journey_form || { post: 'https://docs.google.com/forms/d/e/1FAIpQLSchZjFaOZtC1A2JbTm5K_TjMmmrC6N-Zs7T9LCzMndzzOTUIQ/formResponse', session: 'entry.626601751', src: 'entry.373322878', screen: 'entry.1933156064', answer: 'entry.1231347150', next: 'entry.696230963', ad: 'entry.1748222045' };
  var SESSION_ID = (function () {
    try {
      var s = sessionStorage.getItem('lp_quiz_sid');
      if (!s) { s = Math.random().toString(36).slice(2, 10) + Date.now().toString(36); sessionStorage.setItem('lp_quiz_sid', s); }
      return s;
    } catch (e) { return 'anon' + Math.floor(Math.random() * 1e9); }
  })();
  function logJourney(screen, answer, next) {
    try {
      var fd = new FormData();
      fd.append(JOURNEY.session, SESSION_ID);
      fd.append(JOURNEY.src, QSRC);
      fd.append(JOURNEY.screen, screen || '');
      fd.append(JOURNEY.answer, String(answer || '').replace(/\s+/g, ' ').trim().slice(0, 120));
      fd.append(JOURNEY.next, next || '');
      fd.append(JOURNEY.ad, (QAD ? QAD + '|' : '') + 'v:' + VARIANT);
      fetch(JOURNEY.post, { method: 'POST', mode: 'no-cors', body: fd, keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  /* Ad platforms get commerce signals only. Answers that describe a person's
     religious identity or story stay in our own data (journey log + cart
     attributes) — Meta's Business Tools Terms prohibit sharing data that
     reveals religious belief, and the S&S domain already got flagged for it. */
  function track(name, params) {
    var p = Object.assign({}, params || {}); p.quiz_src = QSRC; p.quiz_variant = VARIANT;
    try { if (window.fbq) fbq('trackCustom', name, p); } catch (e) {}
    try { if (window.ttq) ttq.track(name, p); } catch (e) {}
    try { if (window.gtag) { gtag('event', name, p); if (GADS_CONV[name]) gtag('event', 'conversion', { send_to: GADS_CONV[name] }); } } catch (e) {}
  }
  window.lpQuizTrack = track;

  /* ═══ products + stock ═══ */
  var PRODUCTS = D.PRODUCTS;
  var AVAIL = null;
  (function loadAvailability() {
    try {
      fetch(COLL + '/products.json?limit=50', { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var s = {}, n = 0;
          (d.products || []).forEach(function (pr) {
            if ((pr.variants || []).some(function (v) { return v.available; })) { s[pr.handle] = 1; n++; }
          });
          if (n) AVAIL = s;
        })['catch'](function () {});
    } catch (e) {}
  })();
  /* if the fetch fails AVAIL stays null and everything counts as available,
     so the guard can never make routing worse than the plain table */
  function isAvailable(key) {
    var p = PRODUCTS[key];
    if (!p || !p.handle) return false;
    if (!AVAIL) return true;
    return !!AVAIL[p.handle];
  }

  /* ═══ state ═══ */
  var state = { path: null, color: null, shape: null, brake: null, answers: {}, labels: {}, trail: [], stepIndex: -1 };
  var quizCompleted = false, giftShown = false, pickedKey = null, pendingResume = null;
  var PROG_KEY = 'lp_diamond_quiz_progress';
  function saveProgress() {
    try { localStorage.setItem(PROG_KEY, JSON.stringify({ path: state.path, color: state.color, shape: state.shape, brake: state.brake, answers: state.answers, labels: state.labels, trail: state.trail, stepIndex: state.stepIndex, ts: Date.now() })); } catch (e) {}
  }
  function loadProgress() {
    try { var p = JSON.parse(localStorage.getItem(PROG_KEY) || 'null'); if (p && p.path && Date.now() - (p.ts || 0) < 864e5) return p; } catch (e) {}
    return null;
  }
  function clearProgress() { try { localStorage.removeItem(PROG_KEY); } catch (e) {} }

  var PAGE_HEB = { q1: 'למי השעון', p1: 'צבע', p2: 'צורה', p3: 'איפה יענוד', p4: 'עובדה', p5: 'מה מטריד', p6: 'תשובה',
                   g1: 'צבע', g2: 'צורה', g3: 'הרגע', g4: 'עובדה', g5: 'מה מטריד', g6: 'תשובה' };

  function steps() { return state.path === 'gift' ? D.STEPS_GIFT : D.STEPS_ME; }
  /* shape is skipped for colourful stones (one model), the answer screen when nothing worries them */
  function visible(i) {
    var st = steps()[i];
    if (!st) return true;
    if (st.type === 'shape' && state.color === 'color') return false;
    if (st.type === 'answer' && (!state.brake || state.brake === 'none')) return false;
    return true;
  }
  function nextIndex(i) { var j = i + 1; while (steps()[j] && !visible(j)) j++; return j; }
  function prevIndex(i) { var j = i - 1; while (j >= 0 && !visible(j)) j--; return j; }
  /* for the "N מתוך M" counter the answer card counts until they say nothing worries them,
     so the total does not jump from 6 to 7 the moment an objection is picked */
  function countable(i) { var st = steps()[i]; if (st && st.type === 'answer' && !state.brake) return true; return visible(i); }
  function visibleCount(upto) { var n = 0; for (var i = 0; i < steps().length && i <= upto; i++) if (countable(i)) n++; return n; }

  function computeProduct() { return D.resolve(state.color, state.shape, isAvailable); }
  function picked() { if (!pickedKey) pickedKey = computeProduct(); return PRODUCTS[pickedKey]; }
  function modelName() { var m = picked(); return m ? m.name + (pickedKey.indexOf('_') > -1 ? ' (' + pickedKey.split('_')[1] + ')' : '') : ''; }

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function curScreenId() { if (state.stepIndex < 0) return 'q1'; var st = steps()[state.stepIndex]; return st ? st.id : 'result'; }
  function paras(list) { return (list || []).map(function (t) { return '<p>' + esc(t) + '</p>'; }).join(''); }

  /* ═══ cart ═══ */
  function cartAttrs() {
    return { 'Quiz source': QSRC, 'Quiz path': state.path || '', 'Quiz identity': (state.color || '') + '/' + (state.shape || ''), 'Quiz objection': state.brake || '', 'Quiz model': modelName(), 'Quiz variant': VARIANT };
  }
  function stampCart() {
    try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: cartAttrs() }) }).catch(function () {}); } catch (e) {}
  }
  /* exactly one mystery gift: /cart/update?updates[id]=1, never /cart/add. Lands on the
     studded collection where sections/lp-diamond-match.liquid does the reveal. */
  function previewThemeId() {
    try {
      var pv = new URLSearchParams(location.search).get('preview_theme_id');
      if (!pv && window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') pv = Shopify.theme.id;
      return pv ? String(pv) : '';
    } catch (e) { return ''; }
  }
  function returnUrl() {
    var m = picked();
    var ret = COLL + (COLL.indexOf('?') > -1 ? '&' : '?') + 'dq=1&dqh=' + encodeURIComponent(m.handle || '') + '&dqp=' + (state.path === 'gift' ? 'gift' : 'me');
    var pv = previewThemeId();
    return pv ? ret + '&preview_theme_id=' + pv : ret;
  }
  function matchUrl() {
    var q = new URLSearchParams();
    q.set('attributes[_lp_mystery]', 'quiz');   /* 2026-10-14: mark only, lp-mystery-claim adds the box with the first paid watch */
    q.set('return_to', returnUrl());
    var a = cartAttrs(); for (var k in a) q.set('attributes[' + k + ']', a[k]);
    return SITE + '/cart/update?' + q.toString();
  }
  /* Live: one top-level /cart/update redirect (the proven David path). Theme preview: Shopify
     drops the preview on that redirect and the collection renders on the live theme without
     the reveal, so there the cart is updated by fetch and the page navigates itself. */
  function goToMatch() {
    if (!previewThemeId()) { window.location.href = matchUrl(); return; }
    var body = { attributes: cartAttrs() };
    body.attributes._lp_mystery = 'quiz';
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function () { window.location.href = returnUrl(); })
      ['catch'](function () { window.location.href = matchUrl(); });
  }

  /* ═══ render ═══ */
  function render(html, cls) {
    root.innerHTML = '<div class="frame ' + (cls || '') + '">' + html + '</div>';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  function topbar(hideCount) {
    var total = visibleCount(steps().length) + 1;
    var done = Math.min((state.stepIndex < 0 ? 0 : visibleCount(state.stepIndex)) + 1, total);
    var pct = Math.round((done / total) * 100);
    return '<div class="top">' +
      '<button class="back" data-a="back" aria-label="חזרה"><svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<span class="top-logo">L&amp;P<small>💎</small></span>' +
      (hideCount ? '<span class="count"></span>' : '<span class="count">' + done + ' מתוך ' + total + '</span>') +
      '</div><div class="track"><span class="fill" style="width:' + pct + '%"></span></div>';
  }
  function opt(action, v, label) {
    return '<button class="opt" data-a="' + action + '" data-v="' + esc(v) + '"><span class="lbl">' + esc(label) + '</span></button>';
  }
  /* question number counts real questions only (Q1 + visible colour/shape/single/brake), not fact/answer cards */
  var QTYPES = { color: 1, shape: 1, single: 1, brake: 1 };
  function qtag(st) {
    var n = 1;
    for (var i = 0; i <= state.stepIndex; i++) if (visible(i) && QTYPES[steps()[i].type]) n++;
    return '<p class="qtag">שאלה ' + n + ' · ' + esc(st.tag) + '</p>';
  }
  function eduBox(t) { return t ? '<div class="edu"><span class="edu-label">למה זה משנה</span><span class="edu-body">' + esc(t) + '</span></div>' : ''; }

  function renderGate() {
    var G = D.UI.gate;
    render(
      (HERO ? '<div class="hero"><img src="' + esc(HERO) + '" alt="שעון L&P משובץ על היד"><span class="hero-logo">L&amp;P</span></div>' : '') +
      '<div class="gate-block">' +
      '<p class="eyebrow">' + esc(GATE.eyebrow || G.eyebrow) + '</p>' +
      '<h1 class="h1">' + esc(GATE.headline || G.headline) + ' <span class="g">' + esc(GATE.headline_accent || G.accent) + '</span></h1>' +
      '<p class="sub">' + esc(GATE.subhead || G.sub) + '</p>' +
      '<button class="btn-primary" data-a="start">' + esc(GATE.cta_label || G.cta) + '</button>' +
      '<div class="strip"><span>' + esc(SOCIAL) + ' לקוחות מרוצים</span><i>·</i><span>שנתיים אחריות</span><i>·</i><span>30 ימי ניסיון חינם</span><i>·</i><span>אין צורך במייל</span></div>' +
      '</div>', 'frame-wide');
  }
  function renderResume(p) {
    render('<div class="gate-block" style="padding-top:60px">' +
      '<p class="eyebrow">ברוכים השבים</p>' +
      '<h1 class="h1">ממשיכים <span class="g">מאיפה שעצרת.</span></h1>' +
      '<p class="sub">התשובות נשמרו.</p>' +
      '<button class="btn-primary" data-a="resume">המשך</button>' +
      '<button class="btn-ghost" data-a="restart">להתחיל מחדש</button>' +
      '</div>', 'frame-wide');
  }
  function renderQ1() {
    state.stepIndex = -1;
    render(topbar() +
      '<p class="qtag">שאלה 1 · למי</p>' +
      '<h2 class="q">' + esc(D.UI.q1.title) + '</h2>' +
      '<div class="opts">' + opt('path', 'me', D.UI.q1.me) + opt('path', 'gift', D.UI.q1.gift) + '</div>' +
      '<div class="strip" style="margin-top:34px"><span>משלוח מהיר</span><i>·</i><span>30 ימי ניסיון</span><i>·</i><span>' + esc(SOCIAL) + ' לקוחות</span></div>');
  }
  function renderStep() {
    var st = steps()[state.stepIndex];
    if (!st) return renderLoader();
    if (st.type === 'fact') return renderFact();
    if (st.type === 'answer') return renderAnswer();
    var body;
    if (st.type === 'shape') {
      var tone = state.color === 'silver' ? 'silver' : 'gold';
      body = '<div class="imgopts">' + D.shapesFor(tone).map(function (s) {
        var p = PRODUCTS[s.img[tone]];
        return '<button class="imgopt" data-a="pick" data-v="' + esc(s.v) + '"><img src="' + esc(p.img) + '" alt="" loading="lazy"><span class="lbl">' + esc(s.label) + '</span></button>';
      }).join('') + '</div>';
    } else {
      body = '<div class="opts">' + st.opts.map(function (o) { return opt('pick', o.v, o.label); }).join('') + '</div>';
    }
    render(topbar() + qtag(st) + '<h2 class="q">' + esc(st.title) + '</h2>' + body + eduBox(st.edu));
  }
  function renderFact() {
    var F = D.FACT;
    render(topbar() +
      '<p class="qtag">' + esc(F.tag) + '</p>' +
      '<div class="card">' + (F.img ? '<img class="card-img" src="' + esc(F.img) + '" alt="שעון L&P משובץ על היד">' : '') + '<h2 class="card-h">' + esc(F.h) + '</h2>' + paras(F.body) + '</div>' +
      '<button class="btn-primary" data-a="next">' + esc(F.btn) + '</button>');
  }
  function renderAnswer() {
    var A = (D.ANSWERS[state.path === 'gift' ? 'gift' : 'me'] || {})[state.brake];
    if (!A) { state.stepIndex = nextIndex(state.stepIndex); return renderStep(); }
    var photos = (A.photos && D.SOCIAL_PHOTOS.length)
      ? '<div class="ans-photos">' + D.SOCIAL_PHOTOS.map(function (u) { return '<img src="' + esc(u) + '" alt="לקוח עם שעון L&P משובץ" loading="lazy">'; }).join('') + '</div>' : '';
    render(topbar() +
      '<div class="card">' + (D.ANSWERS.img ? '<img class="card-img" src="' + esc(D.ANSWERS.img) + '" alt="שעון L&P משובץ על היד">' : '') + '<h2 class="card-h">' + esc(A.h) + '</h2>' + paras(A.body) + photos + paras(A.body2) + '</div>' +
      '<button class="btn-primary" data-a="next">' + esc(D.ANSWERS.btn) + '</button>');
  }
  function renderLoader() {
    var lines = D.UI.loader[state.path === 'gift' ? 'gift' : 'me'];
    render('<div class="loader">' +
      '<p class="eyebrow">רגע אחד</p>' +
      '<h2 class="load-title">בונים ' + (state.path === 'gift' ? 'לו' : 'לך') + ' את<br>ההתאמה.</h2>' +
      '<div class="phases">' +
      '<div class="phase" data-ph="0"><span class="ph-dot"></span><span>' + esc(lines[0]) + '</span></div>' +
      '<div class="phase" data-ph="1"><span class="ph-dot"></span><span>' + esc(lines[1]) + '</span></div>' +
      '</div></div>', 'frame-loader');
    logJourney('loader', 'PROC', 'result');
    var ph = root.querySelectorAll('.phase');
    ph[0].classList.add('is-active');
    setTimeout(function () { ph[0].classList.add('is-done'); ph[1].classList.add('is-active'); }, 1500);
    setTimeout(function () { ph[1].classList.add('is-done'); }, 3000);
    setTimeout(renderResult, 3400);
  }

  var tInt = null;
  /* own key, 24h (the V2 offer) */
  function deadline() {
    var d = localStorage.getItem('lp_diamond_deadline');
    if (!d || +d < Date.now()) { d = Date.now() + 24 * 3600 * 1000; localStorage.setItem('lp_diamond_deadline', d); }
    return +d;
  }
  function startTimer() {
    clearInterval(tInt);
    var el = root.querySelector('#tmr'); if (!el) return;
    var tick = function () {
      var ms = deadline() - Date.now(); if (ms < 0) ms = 0;
      el.textContent = pad(Math.floor(ms / 3600000)) + ':' + pad(Math.floor(ms % 3600000 / 60000)) + ':' + pad(Math.floor(ms % 60000 / 1000));
    };
    tick(); tInt = setInterval(tick, 1000);
  }

  function renderResult() {
    var m = picked();
    var gift = state.path === 'gift';
    if (!quizCompleted) {
      quizCompleted = true;
      track('QuizComplete', { end_screen: 'result', path: state.path, objection: state.brake, model: modelName(), color: state.color || '', shape: state.shape || '' });
      logJourney('result', 'COMPLETE|' + modelName(), '');
      stampCart();
      clearProgress();
    }
    try {
      sessionStorage.setItem('lp_diamond_match', JSON.stringify({
        handle: m.handle, key: pickedKey, name: m.name, price: m.price, blurb: m.blurb, img: m.img,
        path: state.path, labels: state.labels, ts: Date.now()
      }));
    } catch (e) {}
    var W = D.UI.win;
    render(topbar(true) +
      '<div class="win">' +
        '<div class="win-badge">🎁</div>' +
        '<h2 class="win-h">' + esc(W.h) + ' <span class="g">' + esc(W.accent) + '</span></h2>' +
        '<p class="win-p">' + esc(gift ? W.gift : W.me) + '</p>' +
        '<div class="timer">⏳ ההטבה שמורה לך עוד <b id="tmr">24:00:00</b></div>' +
      '</div>' +
      '<button class="reveal" data-a="reveal">' +
        '<span class="reveal-imgwrap"><img class="reveal-img" src="' + esc(m.img) + '" alt=""><span class="reveal-chip">🔒 הדגם ' + (gift ? 'שלו' : 'שלך') + ' נבחר</span></span>' +
        '<span class="reveal-t">לצפייה בשעון שבחרנו ' + (gift ? 'לו' : 'לך') + '</span>' +
        '<span class="reveal-s">התמונה מטושטשת בכוונה. לחיצה חושפת את הדגם המדויק בקולקציה, והמתנה שמורה לך ונכנסת לעגלה יחד עם השעון.</span>' +
        '<span class="reveal-btn">לצפייה בשעון שנבחר</span>' +
      '</button>' +
      '<div class="strip"><span>30 ימי ניסיון</span><i>·</i><span>שנתיים אחריות</span><i>·</i><span>' + esc(SOCIAL) + ' לקוחות</span></div>' +
      '<div class="links"><a href="' + esc(COLL) + '" target="_blank" rel="noopener" data-exit="coll_diamond">לכל הקולקציה</a></div>');
    startTimer();
  }

  function maybeShowGiftPopup() {
    if (giftShown) return; giftShown = true;
    var f = state.path === 'gift';
    setTimeout(function () {
      var ov = document.createElement('div'); ov.className = 'dqgift-ov';
      ov.innerHTML = '<div class="dqgift-card">' +
        '<div class="dqgift-badge"><span>🎁</span></div>' +
        '<div class="dqgift-k">רגע לפני שממשיכים</div>' +
        '<div class="dqgift-h">מחכה לך מתנה מסתורית</div>' +
        '<div class="dqgift-p">' + esc(f ? D.UI.popup.gift : D.UI.popup.me) + '</div>' +
        '<button type="button" class="dqgift-btn">' + (f ? 'ממשיכים' : 'בוא נמשיך') + '</button>' +
        '</div>';
      var close = function () { ov.remove(); };
      ov.querySelector('.dqgift-btn').addEventListener('click', close);
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
      document.addEventListener('keydown', function onEsc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onEsc); } });
      document.body.appendChild(ov);
    }, 150);
  }

  /* ═══ events ═══ */
  root.addEventListener('click', function (e) {
    var ex = e.target.closest('[data-exit]');
    if (ex) { try { track('QuizSkipToStore', { exit: ex.getAttribute('data-exit') }); logJourney(curScreenId(), 'store_exit', ex.getAttribute('data-exit')); } catch (err) {} return; }
    var t = e.target.closest('[data-a]');
    if (!t) return;
    var a = t.getAttribute('data-a');
    if (a === 'start') { track('QuizStart'); logJourney('gate', 'start', 'q1'); renderQ1(); return; }
    if (a === 'resume') {
      var p = pendingResume || loadProgress(); pendingResume = null;
      if (!p) { renderGate(); return; }
      state.path = p.path; state.color = p.color || null; state.shape = p.shape || null; state.brake = p.brake || null;
      state.answers = p.answers || {}; state.labels = p.labels || {}; state.trail = p.trail || [];
      state.stepIndex = (typeof p.stepIndex === 'number') ? p.stepIndex : 0;
      track('QuizResume', { path: state.path });
      if (state.stepIndex < 0) renderQ1(); else renderStep();
      return;
    }
    if (a === 'restart') { clearProgress(); pendingResume = null; renderGate(); return; }
    if (a === 'back') {
      if (state.stepIndex <= -1) renderGate();
      else { var j = prevIndex(state.stepIndex); if (j < 0) renderQ1(); else { state.stepIndex = j; renderStep(); } }
      saveProgress(); return;
    }
    if (a === 'path') {
      state.path = t.getAttribute('data-v') === 'gift' ? 'gift' : 'me';
      var lbl = (t.textContent || '').trim();
      state.trail.push(PAGE_HEB.q1 + ': ' + lbl);
      logJourney('q1', lbl, steps()[0].id);
      track('QuizPath', { path: state.path });
      state.stepIndex = 0; saveProgress(); renderStep();
      maybeShowGiftPopup();
      return;
    }
    if (a === 'next') {
      var cur = steps()[state.stepIndex];
      state.stepIndex = nextIndex(state.stepIndex);
      var nx = steps()[state.stepIndex];
      logJourney(cur ? cur.id : '', 'next', nx ? nx.id : 'loader');
      saveProgress(); renderStep();
      return;
    }
    if (a === 'reveal') {
      track('QuizGiftClick', { path: state.path, objection: state.brake, model: modelName(), color: state.color || '', shape: state.shape || '' });
      logJourney('result', 'GIFT_CLICK', 'collection');
      goToMatch();
      return;
    }
    if (a === 'pick') {
      var st = steps()[state.stepIndex];
      var v = t.getAttribute('data-v');
      var lb = t.querySelector('.lbl'); var label = ((lb ? lb.textContent : t.textContent) || '').trim();
      state.answers[st.id] = v; state.labels[st.id] = label;
      pickedKey = null;
      if (st.type === 'color') { state.color = v; if (v === 'color') state.shape = null; track('QuizAnswer', { step: st.id, answer: v, path: state.path }); }
      else if (st.type === 'shape') { state.shape = v; track('QuizAnswer', { step: st.id, answer: v, path: state.path }); }
      else if (st.type === 'brake') { state.brake = v; track('QuizObjection', { objection: v, path: state.path }); }
      else { track('QuizStep', { step: st.id, path: state.path }); }
      state.trail.push((PAGE_HEB[st.id] || st.id) + ': ' + label);
      var ni = nextIndex(state.stepIndex); var nst = steps()[ni];
      logJourney(st.id, label, nst ? nst.id : 'loader');
      t.classList.add('is-selected');
      setTimeout(function () { state.stepIndex = ni; saveProgress(); renderStep(); }, 260);
    }
  });

  track('QuizView', {});
  logJourney('gate', 'view', '');
  pendingResume = loadProgress();
  if (pendingResume) renderResume(pendingResume); else renderGate();
})();
